import {
  Box,
  Card,
  Center,
  Checkbox,
  Container,
  Flex,
  FormLabel,
  Heading,
  Spacer,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import CustomInput from "../../components/CustomInput";
import Select from "react-select";
import { employee_action } from "../../utils/apis";
import { toast } from "react-toastify";
import store from "../../redux/store";
import { getEmployee_list } from "../../redux/slice/employeeSlice";
import { useSelector } from "react-redux";

const list = [
  { label: "Manager", value: "Manager" },
  { label: "Team lead", value: "Team lead" },
  { label: "Team member", value: "Team member" },
];
const list1 = [{ label: "Team member", value: "Team member" }];
const EditEmployee = () => {
  const { employee_list, e_loading } = useSelector((state) => state.employee);
  const loggedInUser = localStorage.getItem("userId");
  const user = JSON.parse(loggedInUser);
  const navigate = useNavigate();
  const location = useLocation();
  const [e_data, setE_data] = useState({});
  const [loading, setLoading] = useState(false);
  const [per, setPer] = useState([]);

  useEffect(() => {
    setE_data({
      ...e_data,
      role: list.filter((v) => v.label === location.state.admin_type)[0],
      name: location.state.username,
      empid: location.state.emp_id,
      motor: location.state.permissions.split(",").find((v) => v === "Motor")
        ? true
        : false,
      health: location.state.permissions.split(",").find((v) => v === "Health")
        ? true
        : false,
      employee: location.state.permissions
        .split(",")
        .find((v) => v === "Employee")
        ? true
        : false,
    });
    setPer(location.state.permissions.split(","));
  }, []);

  const validation = () => {
    if (
      !e_data.empid ||
      !e_data.name ||
      // !e_data.password ||
      (!e_data.motor && !e_data.health && !e_data.employee)
    ) {
      setE_data({
        ...e_data,
        idval: !e_data.empid ? true : false,
        idmess: !e_data.empid ? "employee id is required" : "",
        nameval: !e_data.name ? true : false,
        namemess: !e_data.name ? "name is required" : "",
        // passwordval: !e_data.password ? true : false,
        // passwordmess: !e_data.password ? "password is required" : "",
        perval:
          !e_data.motor && !e_data.health && !e_data.employee ? true : false,
        permess:
          !e_data.motor && !e_data.health && !e_data.employee
            ? "permission is required"
            : "",
      });
      return;
    } else {
      add_employee();
    }
  };

  const add_employee = () => {
    const body = new FormData();
    body.append("action", "update");
    body.append("id", location.state.id);
    body.append("role", e_data.role.value);
    body.append("empid", e_data.empid);
    body.append("name", e_data.name);
    e_data?.role?.value == "Team member" &&
      body.append("assignedto", e_data?.assign?.value);
    e_data.password && body.append("password", e_data.password);
    body.append("permission", per.toString());
    employee_action(body, setLoading).then((v) => {
      if (v.success) {
        toast.success(v.message);
        store.dispatch(getEmployee_list());
        navigate(-1);
      } else {
        toast.error(v.message);
      }
    });
  };
  const e_list = [];
  for (let i = 0; i < employee_list.length; i++) {
    const element = {
      value: employee_list[i].id,
      label:
        employee_list[i].username +
        " (" +
        employee_list[i].emp_id +
        ") " +
        employee_list[i].admin_type,
    };
    e_list.push(element);
  }
  return (
    <Container h={"full"} w={"full"} maxW={"container"}>
      <Flex justify={"space-between"}>
        <Heading fontSize={"xl"}>Edit Employee</Heading>
        <CustomButton
          title={"Back"}
          icon={<BiArrowBack />}
          onClick={() => navigate(-1)}
        />
      </Flex>
      <Spacer h={3} />
      <Card px={3} pb={3}>
        {/* <Flex
          flex={1}
          gap={3}
          flexDirection={["column", "column", "row"]}
          mt={3}
        >
          <FormLabel marginBottom={2} marginLeft={2} mt={3}>
            Role
          </FormLabel>
          <div style={{ flex: 1 }}>
            <Select
              value={e_data.role}
              onChange={(v) => {
                setE_data({ ...e_data, role: v, employee: false });

                setPer((pre) => pre.filter((v) => v !== "Employee"));
              }}
              options={user.role === "Team lead" ? list1 : list}
              placeholder={"Select employee role..."}
            />
          </div>
          <div style={{ flex: 1 }}>
            {e_data?.role?.value == "Team member" && (
              <div style={{ flex: 1 }}>
                <FormLabel marginBottom={2}>Assigned to</FormLabel>
                <Select
                  value={e_data.assign}
                  onChange={(v) => {
                    setE_data({ ...e_data, assign: v });
                  }}
                  options={e_list}
                  placeholder={"Select assigned to"}
                />
              </div>
            )}
          </div>
        </Flex> */}
        <Flex
          flex={1}
          gap={3}
          flexDirection={["column", "column", "row"]}
          mt={3}
        >
          <div style={{ flex: 1 }}>
            <FormLabel marginBottom={2}>Role</FormLabel>
            <Select
              value={e_data.role}
              onChange={(v) => {
                setE_data({ ...e_data, role: v, employee: false });
                setPer((pre) => pre.filter((v) => v !== "Employee"));
              }}
              options={user.role === "Team lead" ? list1 : list}
              placeholder={"Select employee role..."}
            />
          </div>

          <div style={{ flex: 1 }}>
            {e_data?.role?.value == "Team member" && (
              <div style={{ flex: 1 }}>
                <FormLabel marginBottom={2}>Assigned to</FormLabel>
                <Select
                  value={e_data.assign}
                  onChange={(v) => {
                    setE_data({ ...e_data, assign: v });
                  }}
                  options={e_list}
                  placeholder={"Select assigned to"}
                />
              </div>
            )}
          </div>
        </Flex>

        {e_data.role && (
          <>
            <CustomInput
              label1={"Employee id"}
              placeholder1={"Enter empid"}
              value1={e_data.empid}
              onChange1={(e) => {
                setE_data({
                  ...e_data,
                  empid: e.target.value,
                  idmess: "",
                  idval: false,
                });
              }}
              error1={e_data.idmess}
              errorBorder1={e_data.idval && "#f00"}
              label2={"Name"}
              placeholder2={"Enter name"}
              value2={e_data.name}
              onChange2={(e) => {
                setE_data({
                  ...e_data,
                  name: e.target.value,
                  namemess: "",
                  nameval: false,
                });
              }}
              error2={e_data.namemess}
              errorBorder2={e_data.nameval && "#f00"}
            />
            <CustomInput
              label1={"Password"}
              placeholder1={"Enter password"}
              value1={e_data.password}
              onChange1={(e) => {
                setE_data({
                  ...e_data,
                  password: e.target.value,
                  passwordmess: "",
                  passwordval: false,
                });
              }}
              error1={e_data.passwordmess}
              errorBorder1={e_data.passwordval && "#f00"}
              single
              item={
                <>
                  <FormLabel marginBottom={0} marginLeft={2}>
                    Permission
                  </FormLabel>
                  <Flex gap={10}>
                    <Checkbox
                      alignSelf={"self-start"}
                      isChecked={e_data.motor}
                      onChange={(e) => {
                        setE_data({
                          ...e_data,
                          permess: "",
                          motor: e.target.checked,
                        });
                        setPer((pre) =>
                          pre.find((v) => v == "Motor")
                            ? pre.filter((v) => v !== "Motor")
                            : [...pre, "Motor"]
                        );
                      }}
                      my={3}
                      fontSize={"xs"}
                    >
                      Motor
                    </Checkbox>
                    <Checkbox
                      alignSelf={"self-start"}
                      isChecked={e_data.health}
                      onChange={(e) => {
                        setE_data({
                          ...e_data,
                          permess: "",
                          health: e.target.checked,
                        });
                        setPer((pre) =>
                          pre.find((v) => v == "Health")
                            ? pre.filter((v) => v !== "Health")
                            : [...pre, "Health"]
                        );
                      }}
                      my={3}
                      fontSize={"xs"}
                    >
                      Health
                    </Checkbox>
                    {e_data.role.value === "Manager" && (
                      <Checkbox
                        alignSelf={"self-start"}
                        isChecked={e_data.employee}
                        onChange={(e) => {
                          setE_data({
                            ...e_data,
                            permess: "",
                            employee: e.target.checked,
                          });
                          setPer((pre) =>
                            pre.find((v) => v == "Employee")
                              ? pre.filter((v) => v !== "Employee")
                              : [...pre, "Employee"]
                          );
                        }}
                        my={3}
                        fontSize={"xs"}
                      >
                        Employee
                      </Checkbox>
                    )}
                  </Flex>
                  <Text color={"#f00"}>{e_data.permess}</Text>
                </>
              }
            />

            <Center mt={3}>
              <CustomButton
                title={"Update"}
                loading={loading}
                onClick={() => validation()}
                // onClick={() => send_notification()}
              />
            </Center>
          </>
        )}
      </Card>
    </Container>
  );
};

export default EditEmployee;
